import Image from 'components/Image'
import Paragraph from 'components/Paragraph'

import { useMobileDetect } from 'hooks/mobileDetect'

import Styled from './styled'

export default function SectionStep({ data }) {
  const { isMobile } = useMobileDetect()

  const desktopImage = data?.image?.url
  const altDesktopImage = data?.image?.alternativeText
  const mobileImage = data?.mobileImage?.url
  const altMobileImage = data?.mobileImage?.alternativeText
  const title = data?.title

  return (
    <Styled>
      <Paragraph className="title font-semibold">{title}</Paragraph>
      <div className="step-block">
        <div className="step-image">
          {isMobile ? (
            <Image
              className="step-image-mobile"
              src={mobileImage || desktopImage}
              imgixWidth={1920}
              alt={altMobileImage}
            />
          ) : (
            <Image
              className="step-image-desktop"
              src={desktopImage}
              imgixWidth={1920}
              alt={altDesktopImage}
            />
          )}
        </div>
      </div>
    </Styled>
  )
}
